import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ParamService {

    data: Map<string, any> = new Map();

    getData(key: string) {
        return this.data.get(key);
    }

    setData(key: string, value) {
        this.data.set(key, value);
    }
}